import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Notification, NotificationType, Link } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '@epi-forms/helpers';
import { BenefitType, myChoiceBenefits } from '@epi-constants/benefitTypes';
import { IMyChoiceInfo } from '@epi-models/pages/TransferPage';

export const MyChoiceInfo = ({ loadableBenefits }: IMyChoiceInfo) => {
  const { t } = useTranslation();
  const { fontBold } = useTheme();
  const [showMyChoiceInfo, setShowMyChoiceInfo] = useState(false);
  const { watch } = useFormContext();
  const benefitType = watch(FormFields.Benefit);

  const hasTwoMyChoiceBenefits =
    loadableBenefits?.filter(benefit => myChoiceBenefits.includes(benefit))
      .length >= 2;

  useEffect(() => {
    setShowMyChoiceInfo(
      benefitType !== BenefitType.Lunch && hasTwoMyChoiceBenefits
    );
  }, [benefitType, hasTwoMyChoiceBenefits]);

  return (
    <>
      {showMyChoiceInfo && (
        <Notification
          id="my-choice-info"
          type={NotificationType.Info}
          text={
            <>
              <Box>
                <Box fontWeight={fontBold} display="inline" marginRight={0.5}>
                  {t('containers.deposit_money.topup_tab.mychoice_info.title')}
                </Box>
                <Box display="inline">
                  {t(
                    'containers.deposit_money.topup_tab.mychoice_info.content'
                  )}
                </Box>
              </Box>
              <Box marginTop={3}>
                <Link
                  href={t(
                    'containers.deposit_money.topup_tab.mychoice_info.link_url'
                  )}
                  target="_blank"
                >
                  {t(
                    'containers.deposit_money.topup_tab.mychoice_info.link_text'
                  )}
                </Link>
              </Box>
            </>
          }
          onClose={() => {
            setShowMyChoiceInfo(false);
          }}
        />
      )}
    </>
  );
};
